// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__M6chi","icon":"styles_icon__2CiOz"};